export default "<p>\n  declaracao-financiamento works!\n</p>\n";